import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bdda7f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app pb20" }
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading-text" }, "Carregando...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "soon-badge mb-3" }, " Em breve ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2 filter-title" }, "Filtros")
], -1))
const _hoisted_9 = { class: "d-flex flex-column justify-content-start" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 filter-label" }, "Estado", -1))
const _hoisted_11 = { class: "select-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Todos", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1))
const _hoisted_15 = { class: "d-flex flex-column justify-content-start mt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 filter-label" }, "Tipo de imóvel", -1))
const _hoisted_17 = { class: "select-container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Todos", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1))
const _hoisted_21 = { class: "d-flex flex-column justify-content-start mt-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 filter-label" }, "VGV", -1))
const _hoisted_23 = { class: "d-flex gap-2 mt-1" }
const _hoisted_24 = { class: "d-flex flex-column justify-content-start mt-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 filter-label" }, "ROI", -1))
const _hoisted_26 = { class: "d-flex gap-2 mt-1" }
const _hoisted_27 = { class: "d-flex flex-column justify-content-start mt-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 filter-label" }, "Área construída", -1))
const _hoisted_29 = { class: "d-flex gap-2 mt-1" }
const _hoisted_30 = { class: "w100" }
const _hoisted_31 = { class: "marketplace-header" }
const _hoisted_32 = { class: "toggle-sidebar-btn" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Marketplace", -1))
const _hoisted_34 = { class: "market-items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_Sidebar, {
            sidebarOpen: _ctx.sidebarOpen,
            isMobile: _ctx.isMobile
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.status) = $event)),
                    class: "form-control",
                    disabled: ""
                  }, _hoisted_13, 512), [
                    [_vModelSelect, _ctx.status]
                  ]),
                  _hoisted_14
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.status) = $event)),
                    class: "form-control",
                    disabled: ""
                  }, _hoisted_19, 512), [
                    [_vModelSelect, _ctx.status]
                  ]),
                  _hoisted_20
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.minVgv) = $event)),
                    type: "number",
                    class: "form-control filter-number-input",
                    placeholder: "Min",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.minVgv]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.maxVgv) = $event)),
                    type: "number",
                    placeholder: "Máx",
                    class: "form-control filter-number-input",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.maxVgv]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.minVgv) = $event)),
                    type: "number",
                    class: "form-control filter-number-input",
                    placeholder: "Min",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.minVgv]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.maxVgv) = $event)),
                    type: "number",
                    placeholder: "Máx",
                    class: "form-control filter-number-input",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.maxVgv]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.minVgv) = $event)),
                    type: "number",
                    class: "form-control filter-number-input",
                    placeholder: "Min",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.minVgv]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.maxVgv) = $event)),
                    type: "number",
                    placeholder: "Máx",
                    class: "form-control filter-number-input",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.maxVgv]
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["sidebarOpen", "isMobile"]),
          _createElementVNode("div", {
            class: _normalizeClass(["opportunities-main", { 'isNotMobile': !_ctx.isMobile }])
          }, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("i", {
                    class: "fa-solid fa-sliders",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleSidebar()))
                  })
                ]),
                _hoisted_33
              ]),
              _createElementVNode("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opportunitiesFromBI, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "loop-box"
                  }, [
                    _createVNode(_component_Card, {
                      imageNameTitle: _ctx.getImageNameTitle(item.controle_status !== 'analise' ? item.title : item.tipo),
                      title: item.controle_status !== 'analise' ? item.title : item.tipo,
                      status: item.controle_status,
                      cityAndState: `${item.cidade} - ${item.estado}`,
                      location: `${item.logradouro} - ${item.bairro}`,
                      areaLote: item.area_lote,
                      recommendation: item.tags.length > 0 ? item.tags[0].descricao : '',
                      biURL: item.url,
                      gidImovel: item.gid_imovel,
                      nearby: item.tags[1] ? item.tags[1].descricao : '',
                      iconLeft: item.tags.length > 0 ? item.tags[0].tagenum : 'default-left-icon',
                      iconRight: item.tags.length > 1 ? item.tags[1].tagenum : 'default-right-icon',
                      "image-map-name": item.image,
                      "tag-vgv": "VGV",
                      "tag-vgv-value": item.vgv ? _ctx.formatVgvValue(item.vgv) : null,
                      "tag-roi": "ROI",
                      "tag-roi-value": item.roi ? item.roi + '%' : null,
                      "tag-vgv-color": "#bca9f5",
                      id: item.id_bis,
                      disableStudyView: true,
                      class: "lcts-card-component"
                    }, null, 8, ["imageNameTitle", "title", "status", "cityAndState", "location", "areaLote", "recommendation", "biURL", "gidImovel", "nearby", "iconLeft", "iconRight", "image-map-name", "tag-vgv-value", "tag-roi-value", "id"])
                  ]))
                }), 128))
              ])
            ])
          ], 2)
        ]))
  ]))
}